import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    'nav.services': 'Services',
    'nav.approach': 'Methodology',
    'nav.about': 'About',
    'nav.sectors': 'Sectors',
    'nav.contact': 'Contact',
    'nav.products': 'Products',
    'nav.quote': 'Request a Quote',

    'hero.title': 'From Business Understanding to Execution-Ready Digital Solutions',
    'hero.desc': 'We help organizations transform challenges and ideas into scalable digital systems through business analysis, solution design, and system development.',
    'hero.cta': 'Request a Quote',
    'hero.cta2': 'View Products',

    'about.overline': 'About Us',
    'about.title': 'Who We Are',
    'about.p1': 'Nexa Solutions is a business-focused digital solutions company.',
    'about.p2': 'We start with deep business understanding, analyze the current state, identify real needs, and design practical, scalable solutions.',

    'values.overline': 'Our Value',
    'values.title': 'The Value We Deliver',
    'values.v1': 'Clear understanding before execution',
    'values.v2': 'Reduced risk and errors',
    'values.v3': 'Scalable, integrable solutions',
    'values.v4': 'Data transformed into decisions',

    'services.overline': 'Our Services',
    'services.title': 'Core Services',
    'services.s1': 'Business Analysis',
    'services.s2': 'Solution Design',
    'services.s3': 'System Development',
    'services.s4': 'System Integration',
    'services.s5': 'AI Solutions',
    'services.s6': 'Executive Decision Platforms',
    'services.s7': 'Spatial Intelligence Platforms',
    'services.s8': 'Digital Advisory',

    'method.overline': 'Our Methodology',
    'method.title': 'How We Work',
    'method.m1': 'Understand',
    'method.m2': 'Analyze',
    'method.m3': 'Design',
    'method.m4': 'Document',
    'method.m5': 'Execute',

    'sectors.overline': 'Target Sectors',
    'sectors.title': 'Industries We Serve',
    'sectors.s1': 'Government',
    'sectors.s2': 'Banks & Finance',
    'sectors.s3': 'Startups',
    'sectors.s4': 'Digital Transformation',
    'sectors.s5': 'NGOs',
    'sectors.s6': 'Real Estate Development & Property Management',

    'products.overline': 'Our Products',
    'products.title': 'Our Products',
    'products.subtitle': 'Ready digital solutions designed to improve your business and support better decision-making.',
    'products.cta': 'Request a Quote',
    'products.viewDetails': 'View Details',
    'products.viewAll': 'View All Products',
    'products.features': 'Key Features',
    'products.gallery': 'Gallery',
    'products.backToProducts': 'Back to Products',
    'products.empty': 'No products available at the moment.',

    'articles.overline': 'Insights',
    'articles.title': 'Latest Articles',
    'articles.subtitle': 'Selected insights from our blog — business analysis, digital transformation, and scalable solutions.',
    'articles.readMore': 'Read More',
    'articles.viewAll': 'View All Articles',

    'contact.overline': 'Get Started',
    'contact.title': 'Contact Us',
    'contact.subtitle': 'Start with understanding your business and move towards a clear, execution-ready digital solution.',
    'contact.name': 'Full Name',
    'contact.email': 'Email Address',
    'contact.phone': 'Phone Number',
    'contact.org': 'Organization',
    'contact.message': 'Tell us about your challenge...',
    'contact.submit': 'Send Message',
    'contact.success': 'Message sent successfully!',
    'contact.info.email': 'info@nexa.sa',
    'contact.info.phone': '+966-533-993-007',

    'quote.title': 'Request a Quote',
    'quote.subtitle': 'Fill in the details and our team will get back to you with a custom proposal.',
    'quote.name': 'Full Name',
    'quote.company': 'Company / Organization',
    'quote.phone': 'Phone Number',
    'quote.email': 'Email Address',
    'quote.city': 'City',
    'quote.product': 'Product Required',
    'quote.desc': 'Brief description of your need',
    'quote.submit': 'Submit Request',
    'quote.success': 'Your request has been submitted. We will contact you shortly.',
    'quote.selectProduct': 'Select a product',

    'footer.rights': '2025 Nexa Solutions. All rights reserved.',
    'footer.tagline': 'From Business Understanding to Execution-Ready Digital Solutions.',
  },
  ar: {
    'nav.services': 'الخدمات',
    'nav.approach': 'المنهجية',
    'nav.about': 'من نحن',
    'nav.sectors': 'القطاعات',
    'nav.contact': 'تواصل معنا',
    'nav.products': 'المنتجات',
    'nav.quote': 'اطلب عرض سعر',

    'hero.title': 'من فهم الأعمال إلى حلول رقمية قابلة للتنفيذ',
    'hero.desc': 'نساعد الجهات على تحويل التحديات والأفكار إلى أنظمة عملية قابلة للتوسع من خلال تحليل الأعمال، تصميم الحلول، وتنفيذ الأنظمة الرقمية.',
    'hero.cta': 'اطلب عرض سعر',
    'hero.cta2': 'استعرض المنتجات',

    'about.overline': 'من نحن',
    'about.title': 'من نحن',
    'about.p1': 'نحن شركة Nexa Solutions، متخصصة في تحليل الأعمال وبناء الأنظمة الرقمية.',
    'about.p2': 'نبدأ بفهم عميق للأعمال، ثم تحليل الواقع، وتحديد الاحتياج الحقيقي، وتصميم حلول عملية قابلة للتنفيذ والتوسع.',

    'values.overline': 'القيمة المضافة',
    'values.title': 'القيمة التي نقدمها',
    'values.v1': 'وضوح كامل للاحتياج قبل التنفيذ',
    'values.v2': 'تقليل المخاطر والأخطاء',
    'values.v3': 'حلول قابلة للتوسع والتكامل',
    'values.v4': 'تحويل البيانات إلى قرارات',

    'services.overline': 'خدماتنا',
    'services.title': 'خدماتنا الأساسية',
    'services.s1': 'تحليل الأعمال',
    'services.s2': 'تصميم الحلول',
    'services.s3': 'تطوير الأنظمة',
    'services.s4': 'ربط الأنظمة',
    'services.s5': 'حلول الذكاء الاصطناعي',
    'services.s6': 'منصات القرار التنفيذي',
    'services.s7': 'منصات الذكاء المكاني',
    'services.s8': 'الاستشارات الرقمية',

    'method.overline': 'منهجيتنا',
    'method.title': 'كيف نعمل',
    'method.m1': 'فهم الأعمال',
    'method.m2': 'تحليل الواقع',
    'method.m3': 'تصميم الحل',
    'method.m4': 'توثيق المتطلبات',
    'method.m5': 'دعم التنفيذ',

    'sectors.overline': 'القطاعات المستهدفة',
    'sectors.title': 'القطاعات التي نخدمها',
    'sectors.s1': 'الجهات الحكومية',
    'sectors.s2': 'البنوك والمؤسسات المالية',
    'sectors.s3': 'الشركات الناشئة',
    'sectors.s4': 'الشركات في مرحلة التحول الرقمي',
    'sectors.s5': 'المنظمات غير الربحية',
    'sectors.s6': 'التطوير العقاري وإدارة الأملاك',

    'products.overline': 'منتجاتنا',
    'products.title': 'منتجاتنا',
    'products.subtitle': 'حلول رقمية جاهزة تساعدك على تحسين أعمالك واتخاذ قرارات أفضل.',
    'products.cta': 'اطلب عرض سعر',
    'products.viewDetails': 'عرض التفاصيل',
    'products.viewAll': 'عرض جميع المنتجات',
    'products.features': 'أهم المزايا',
    'products.gallery': 'معرض الصور',
    'products.backToProducts': 'العودة للمنتجات',
    'products.empty': 'لا توجد منتجات حالياً.',

    'articles.overline': 'مقالات ورؤى',
    'articles.title': 'أحدث المقالات',
    'articles.subtitle': 'مختارات من مدونتنا حول تحليل الأعمال والتحول الرقمي وبناء الحلول القابلة للتوسع.',
    'articles.readMore': 'اقرأ المزيد',
    'articles.viewAll': 'جميع المقالات',

    'contact.overline': 'الخطوة الأولى',
    'contact.title': 'تواصل معنا',
    'contact.subtitle': 'ابدأ معنا من فهم أعمالك إلى بناء حل رقمي واضح وقابل للتنفيذ.',
    'contact.name': 'الاسم الكامل',
    'contact.email': 'البريد الإلكتروني',
    'contact.phone': 'رقم التواصل',
    'contact.org': 'الجهة أو المؤسسة',
    'contact.message': 'صف لنا التحدي الذي تواجهه...',
    'contact.submit': 'إرسال الرسالة',
    'contact.success': 'تم إرسال رسالتك بنجاح!',
    'contact.info.email': 'info@nexa.sa',
    'contact.info.phone': '+966-533-993-007',

    'quote.title': 'اطلب عرض سعر',
    'quote.subtitle': 'أكمل البيانات التالية وسيتواصل معك فريقنا بعرض مخصص.',
    'quote.name': 'الاسم',
    'quote.company': 'اسم الجهة / الشركة',
    'quote.phone': 'رقم الجوال',
    'quote.email': 'البريد الإلكتروني',
    'quote.city': 'المدينة',
    'quote.product': 'المنتج المطلوب',
    'quote.desc': 'وصف مختصر للاحتياج',
    'quote.submit': 'إرسال الطلب',
    'quote.success': 'تم إرسال طلبك بنجاح. سنتواصل معك قريباً.',
    'quote.selectProduct': 'اختر منتج',

    'footer.rights': '٢٠٢٥ نيكسا سولوشينز. جميع الحقوق محفوظة.',
    'footer.tagline': 'من فهم الأعمال إلى حلول رقمية جاهزة للتنفيذ.',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('nexa-lang') || 'ar');
  const isRTL = language === 'ar';

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
    document.body.dir = isRTL ? 'rtl' : 'ltr';
    localStorage.setItem('nexa-lang', language);
  }, [language, isRTL]);

  const toggleLanguage = () => setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  const t = (key) => translations[language]?.[key] || translations.en[key] || key;

  return (
    <LanguageContext.Provider value={{ language, isRTL, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;
